// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"364":"dash-school","800":"dash-rater","933":"dash-admin"}[chunkId] + "." + {"364":"21d3c853","800":"662dfc9b","933":"4079472d"}[chunkId] + ".css";
};